export enum PlayerNoteReasonType {
  DeactivatedNumbers = 1,
  DeactivatedAccount = 2,
  FlaggedPlayer = 3,
  Other = 4
}
